import {
    useState,
    Fragment
} from "react";
import {
    View
} from "react-native";
import type IChangePasswordModalProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitSnackBar,
    NCoreUIKitTheme,
    TextInput,
    Button,
    Modal,
    Text
} from "ncore-ui-kit";
import RESTServiceContext from "../../../../services/restAPI/context";

const ChangePasswordModal = ({
    isVisible,
    onClose
}: IChangePasswordModalProps) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [
        isSubmitting,
        setIsSubmitting
    ] = useState<boolean>(false);

    const [
        oldPassword,
        setOldPassword
    ] = useState<string>("");

    const [
        newPassword,
        setNewPassword
    ] = useState<string>("");

    const [
        newPasswordConfirm,
        setNewPasswordConfirm
    ] = useState<string>("");

    const handleResetStates = () => {
        setNewPasswordConfirm("");
        setOldPassword("");
        setNewPassword("");
        onClose();
    };

    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword || !newPasswordConfirm) {
            NCoreUIKitSnackBar.open({
                title: localize("fill-all-fields")
            });
            return;
        }

        if (newPassword !== newPasswordConfirm) {
            NCoreUIKitSnackBar.open({
                title: localize("passwords-do-not-match")
            });
            return;
        }

        try {
            setIsSubmitting(true);
            const result = await RESTServiceContext.action("changePassword", {
                newPassword: newPassword,
                oldPassword: oldPassword
            });

            if (result.isError) {
                NCoreUIKitSnackBar.open({
                    title: result.message || localize("something-went-wrong")
                });
            } else {
                NCoreUIKitSnackBar.open({
                    title: result.message || "Şifre başarıyla değiştirildi."
                });
                handleResetStates();
            }
        } catch (err) {
            console.error(err);
            NCoreUIKitSnackBar.open({
                title: localize("something-went-wrong")
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return <Fragment>
        <Modal
            onClosed={handleResetStates}
            id="change-password-modal"
            portalName="modal-system"
            isActive={isVisible}
        >
            <View
                style={[
                    stylesheet.container,
                    {
                        backgroundColor: colors.project.brandWhite,
                        padding: spaces.spacingXl,
                        borderRadius: radiuses.lg,
                        gap: spaces.spacingXl
                    }
                ]}
            >
                <View
                    style={stylesheet.headerContainer}
                >
                    <Text
                        variant="titleLargeSize"
                    >
                        {localize("change-password")}
                    </Text>
                </View>
                <View
                    style={[
                        stylesheet.formContainer,
                        {
                            gap: spaces.spacingMd
                        }
                    ]}
                >
                    <TextInput
                        placeholder={localize("old-password")}
                        title={localize("old-password")}
                        onChangeText={setOldPassword}
                        spreadBehaviour="stretch"
                        value={oldPassword}
                        variant="hidden"
                    />
                    <TextInput
                        placeholder={localize("new-password")}
                        title={localize("new-password")}
                        onChangeText={setNewPassword}
                        spreadBehaviour="stretch"
                        value={newPassword}
                        variant="hidden"
                    />
                    <TextInput
                        placeholder={localize("new-password-confirm")}
                        title={localize("new-password-confirm")}
                        onChangeText={setNewPasswordConfirm}
                        value={newPasswordConfirm}
                        spreadBehaviour="stretch"
                        variant="hidden"
                    />
                </View>
                <View
                    style={[
                        stylesheet.footerContainer,
                        {
                            gap: spaces.spacingMd
                        }
                    ]}
                >
                    <Button
                        customBorderColor="secondaryButton"
                        customColor="secondaryButton"
                        onPress={handleResetStates}
                        title={localize("cancel")}
                        variant="filled"
                    />
                    <Button
                        onPress={handleChangePassword}
                        title={localize("save")}
                        isLoading={isSubmitting}
                    />
                </View>
            </View>
        </Modal>
    </Fragment>;
};

export default ChangePasswordModal;
